
import { BaseService } from "../BaseService";
import { NoseurObject } from "@ronuse/noseur";

export interface ISupportCategory {
    name: string;
    platform: string;
    created_at: string;
    description: string;
    external_id: string;
    icon_location: string;
}

export class SupportCategoryService extends BaseService {

    protected static instance: SupportCategoryService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!SupportCategoryService.instance) SupportCategoryService.instance = new SupportCategoryService();
        return SupportCategoryService.instance;
    }

    querySupportCategories(query: NoseurObject<string | number> = { page: 1, size: 10 }): Promise<any> {
        return this.report(this.transport.get("/hera/api/v1/support/category", { cache: true, query: this.normalizeParams(query) }));
    }

    getSingleSupportCategory(id: string): Promise<any> {
        return this.report(this.transport.get(`/hera/api/v1/support/category/${id}`, { cache: true }));
    }

}
